module.exports = __webpack_public_path__ + "img/carousel-item-3.2db55bfb.png";